<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bNoyFS/tc-custom/9781488058653.jpg?1728259324170" alt="This image is the cover for the book Five Days of Christmas, Morgan's Mercenaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Five Days of Christmas, Morgan's Mercenaries
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i></b><b> bestselling author Lindsay McKenna revisits a fan-favorite tale of a holiday happily-ever-after, originally published in 2001</b><br/><br/>Colt Hamlin doesn’t expect much under his tree this Christmas. After all, the world-weary mercenary is just looking to get his life back on track. But when his boss’s wife decides to work a little matchmaking magic, Colt finds himself face to face with Montana’s prettiest widow, Abbie Clemens. And their chemistry is nothing short of electric…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsay McKenna
      </h2>
      
      <p class="authorDescription body article">A U.S. Navy veteran, she&#160;pioneered the military romance in 1993 with Captive of Fate, Silhouette Special edition. In 1989, she pioneered the 3-book series coming out monthly with the Love &amp; Glory series.&#160; Her heart is on honoring our military men and women.&#160; Creator of the Wyoming Series and Shadow Warriors series for HQN, she writes emotionally intense love and suspense stories. Visit her online at <a href="http://www.LindsayMcKenna.com">www.LindsayMcKenna.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e8a16372